import RoadmapReportPDF from './RoadmapReportPdf';

const Report = ({
    reportData,
    selectedSchool,
    selectedTutorGroupLead,
    selectedTutorGroup,
    selectedYearGroup,
    selectedStudentStatuses,
    selectedInterventionTypes,
    includeNormalAttendance,
    includeLowAttendance,
    handleStudentClick,
}) => {

    // current time formatted as "HH:MM DD/MM/YYYY" time first
    let currentTime = new Date().toLocaleString('en-GB', {
        hour: '2-digit',
        minute: '2-digit',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
    currentTime = currentTime.split(', ').reverse().join(' ');

    // Map the reportData roadmapSteps to the combined data of the complete, inProgress and upcoming arrays and get the first 8
    const roadmaps = reportData.map(roadmap => {
        const { complete, in_progress, upcoming, ...rest } = roadmap;
        const roadmapSteps = [...complete, ...in_progress, ...upcoming].slice(0, 8);
        return {
            ...rest,
            roadmapSteps
        };
    })

    return (
        <>
            <div className='roadmap-report-cont flex-col'>


                <div className="flex-row align-center">
                    <h2>Roadmap Report</h2>
                    <span>{currentTime}</span>
                </div>

                <div className="details-list">
                    <ul className="report-details-list">
                        <li><b>School</b> - {selectedSchool && selectedSchool.name && selectedSchool.name}</li>
                        {selectedTutorGroupLead && selectedTutorGroupLead.name &&
                            <li>
                                <b>Intervention lead</b> - <span>{selectedTutorGroupLead.name}</span>
                            </li>
                        }
                        {selectedTutorGroup && selectedTutorGroup.name &&
                            <li>
                                <b>Tutor Group</b> - <span>{selectedTutorGroup.name}</span>
                            </li>
                        }
                        {selectedYearGroup && selectedYearGroup.year &&
                            <li>
                                <b>Year Group</b> - <span>{selectedYearGroup.year}</span>
                            </li>
                        }
                        {selectedStudentStatuses && selectedStudentStatuses.length > 0 &&
                            <li>
                                <b>Student Statuses</b> -
                                {selectedStudentStatuses && selectedStudentStatuses[0] && selectedStudentStatuses.map((selectedStatus, index) =>
                                    <>
                                        <span>{selectedStatus.name} {index !== selectedStudentStatuses.length && ', '}</span>
                                    </>
                                )}
                            </li>
                        }
                        {selectedInterventionTypes && selectedInterventionTypes.length > 0 &&
                            <li>
                                <b>Intervention Types</b> -
                                {selectedInterventionTypes && selectedInterventionTypes[0] && selectedInterventionTypes.map((selectedType, index) =>
                                    <>
                                        <span>{selectedType.name} {index !== selectedInterventionTypes.length && ', '}</span>
                                    </>
                                )}
                            </li>
                        }
                        <li>
                            <b>Attendance</b> -
                            <>
                                <span>
                                    {includeNormalAttendance && includeLowAttendance ? 'Normal, Low' : ''}
                                    {includeNormalAttendance && !includeLowAttendance ? 'Normal' : ''}
                                    {includeLowAttendance && !includeNormalAttendance ? 'Low' : ''}
                                </span>
                            </>
                        </li>
                    </ul>
                </div>

                <div className="flex-row justify-start">
                    <div className="flex-row">
                        <span className='green-indicator'></span>
                        <span className='indicator-name'>Complete</span>
                    </div>
                    <div className="flex-row">
                        <span className='orange-indicator'></span>
                        <span className='indicator-name'>In Progress</span>
                    </div>
                    <div className="flex-row">
                        <span className='white-indicator'></span>
                        <span className='indicator-name'>Upcoming</span>
                    </div>
                </div>

                {roadmaps && (
                    <>
                        {roadmaps.map((roadmap, index) => (
                            <div className="roadmap-cont align" key={index}>

                                {/* Student info container */}
                                <div className="student-info-cont flex-col justify-center">
                                    <p className="student-title" onClick={() => handleStudentClick(roadmap?.pupil_info?.id)}>{roadmap?.pupil_info?.name}</p>
                                    <p>Year {roadmap?.pupil_info?.year}</p>
                                    <p>Ta: {roadmap?.pupil_info?.tutor}</p>
                                </div>

                                <div className="roadmap-steps-cont flex-row justify-start">
                                    {roadmap.roadmapSteps.map((step, index) => (
                                        !step?.status
                                            ? <> </>
                                            : <div className={`roadmap-step ${step?.status} flex-col`} key={step?.status + index}>
                                                <p className="step-level">Level {step?.level?.charAt(step.level.length - 1)}</p>
                                                <p className="step-label">{step?.label}</p>

                                            </div>
                                    ))}
                                </div>

                            </div>
                        ))}
                    </>
                )}

            </div>
            <div className="separator"></div>
            <RoadmapReportPDF
                roadmaps={roadmaps}
                selectedSchool={selectedSchool}
                selectedTutorGroupLead={selectedTutorGroupLead}
                selectedTutorGroup={selectedTutorGroup}
                selectedYearGroup={selectedYearGroup}
                selectedInterventionTypes={selectedInterventionTypes}
                selectedStudentStatuses={selectedStudentStatuses}
                currentTime={currentTime}
                includeNormalAttendance={includeNormalAttendance}
                includeLowAttendance={includeLowAttendance}
            />

        </>
    )
};

export default Report;
